/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_FooterInputs */

const en_email_footer = /** @type {(inputs: Email_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is an automated email. Please do not reply.`)
};

const pt_br2_email_footer = /** @type {(inputs: Email_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este é um e-mail automático. Por favor, não responda.`)
};

/**
* | output |
* | --- |
* | "This is an automated email. Please do not reply." |
*
* @param {Email_FooterInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_footer = /** @type {((inputs?: Email_FooterInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_FooterInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_footer(inputs)
	return pt_br2_email_footer(inputs)
});